import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import StatsIllustrationSrc from "images/server-illustration-2.svg";
import { ReactComponent as SvgDotPattern } from "images/dot-pattern.svg";

const Container = tw.div`relative bg-white -mx-8`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto p-4 py-4 md:py-4`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`rounded-2xl mt-4 md:w-5/12 flex-shrink-0 md:h-auto relative`;
const TextColumn = styled(Column)(props => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft ? tw`md:mr-12 lg:mr-16 md:order-first` : tw`md:ml-12 lg:ml-16 md:order-last`
]);

const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded-2xl bg-contain bg-no-repeat bg-center h-full`
]);
const TextContent = tw.div`lg:py-8 text-center md:text-left`;

const Subheading = tw(SubheadingBase)`text-center text-gray-900 md:text-left`;
const Heading = tw(SectionHeading)`text-gray-800 font-black text-3xl md:text-5xl leading-snug max-w-3xl text-center md:text-left `;
const Description = tw.p`mt-4 text-center md:text-left text-sm lg:text-base leading-relaxed text-gray-700`;

const Statistics = tw.div`flex flex-col items-center sm:block text-center md:text-left mt-4`;
const Statistic = tw.div`text-center sm:inline-block sm:mr-12 last:mr-0 mt-4`;
const Value = tw.div`font-bold text-lg sm:text-xl lg:text-2xl text-black tracking-wide`;
const Key = tw.div`font-bold text-black`;

const PrimaryButton = tw.button`tracking-wider rounded-full font-bold px-8 lg:px-10 py-3 bg-black text-white hocus:bg-[#fc0606] focus:outline-none`;

const DecoratorBlob = styled(SvgDotPattern)(props => [
  tw`w-20 h-20 absolute right-0 bottom-0 transform translate-x-1/2 translate-y-1/2 fill-current text-primary-500 -z-10`
]);

export default ({
  subheading = "Profesjonalne wsparcie IT",
  heading = (
    <>
      Twoja wizja. <wbr />  <span tw="text-primary-500">Nasze rozwiązania.</span>
    </>
  ),
  description = "Dostarczamy innowacyjne oraz kompleksowe rozwiązania informatyczne. Nasze wieloletnie doświadczenie, kreatywność i poświęcenie pozwala wyróżnić naszą firmę na rynku usług informatycznych. Skontaktuj się z nami, aby dowiedzieć się jak możemy wspomóc działalność Twojej firmy.",
  primaryButtonText = "Napisz do nas",
  primaryButtonUrl = "#",
  imageSrc = StatsIllustrationSrc,
  imageCss = null,
  imageContainerCss = null,
  imageDecoratorBlob = false,
  imageDecoratorBlobCss = null,
  imageInsideDiv = true,
  statistics = null,
  textOnLeft = false
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  //Change the statistics variable as you like, add or delete objects
  const defaultStatistics = [
    {
      key: "Automatyzacja",
      value: "5 minut"
    },
    {
      key: "Bezpieczeństwo",
      value: "100%"
    },
    {
      key: "Bateria",
      value: "5-10 lat"
    },
    {
      key: "Papieru",
      value: "0 szt."
    }
  ];

  if (!statistics) statistics = defaultStatistics;

  return (
    <Container id="oNas">
      <TwoColumn css={!imageInsideDiv && tw`md:items-center`}>
        <ImageColumn css={imageContainerCss}>
          {imageInsideDiv ? <Image imageSrc={imageSrc} css={imageCss} /> : <img src={imageSrc} css={imageCss} alt="" />}
          {imageDecoratorBlob && <DecoratorBlob css={imageDecoratorBlobCss} />}
        </ImageColumn>
        <TextColumn textOnLeft={textOnLeft}>
          <TextContent>
            {subheading && <Subheading>{subheading}</Subheading>}
            <Heading>{heading}</Heading>
            <Description>{description}</Description>
            {/* <Statistics>
              {statistics.map((statistic, index) => (
                <Statistic key={index}>
                  <Value>{statistic.value}</Value>
                  <Key>{statistic.key}</Key>
                </Statistic>
              ))}
            </Statistics> */}
             {/* <PrimaryButton as="a" href={primaryButtonUrl}>
              {primaryButtonText}
            </PrimaryButton> */}
          </TextContent>
          {/* <PrimaryButton as="a" href={primaryButtonUrl}>
            {primaryButtonText}
          </PrimaryButton> */}
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
